import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DomainCacheService } from './domain-cache.service';

const  baseRef = 'status-entidade';
const route = {
  listar: `${baseRef}`
}

@Injectable({
  providedIn: 'root'
})
export class StatusEntidadeService {

  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) { }

  listar() {
    return this.domainCache.getOrLoad(route.listar, () =>
      this.apiService.get<any[]>(route.listar, undefined, undefined, true)
    );
  }
}
